import { createFileRoute } from '@tanstack/react-router'
import { Barcode } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { EmptyState } from '@/shared/ui/empty-state'
import { PageHeader } from '@/widgets/app-shell/page-header'

export const Route = createFileRoute('/_authed/recebimentos/boletos')({
  component: Page,
})

function Page() {
  const { t } = useTranslation(['nav', 'common'])
  const titulo = t('nav:receivables.slips')

  return (
    <>
      <PageHeader title={titulo} />
      <EmptyState icon={Barcode} title={titulo} description={t('common:states.empty')} />
    </>
  )
}
